import React from 'react';
import './SocialNetwork.css';
import webUtils from '../../../utils/webUtils';
import Fb from '../../../assets/images/icons/footer/sn-fb-atfnydiyc3.svg';
import Ig from '../../../assets/images/icons/footer/sn-ig-0hq6x9ryvk.svg';
import In from '../../../assets/images/icons/footer/sn-in-qhdjvzrma9.svg';
import Tt from '../../../assets/images/icons/footer/sn-tt-0v7twvieay.svg';
import Yt from '../../../assets/images/icons/footer/sn-youtube-zrmthr3bzw.svg';

export default function SocialNetwork() {
  return (
    <div className="pf-footer-sn">
      <>
        <div className="pf-footer-sn-icon">
          <a href={webUtils.fbLink()} target="_blank" rel="noreferrer noopener nofollow">
            <img src={Fb} alt = {'Facebook'} />
          </a>
        </div>
        <div className="pf-footer-sn-icon">
          <a href={webUtils.igLink()} target="_blank" rel="noreferrer noopener nofollow">
            <img src={Ig}  alt = {'Instagram'}/>
          </a>
        </div>
        <div className="pf-footer-sn-icon">
          <a href={webUtils.ytLink()} target="_blank" rel="noreferrer noopener nofollow">
            <img src={Yt} alt = {'Youtube'} />
          </a>
        </div>
      </>
      <div className="pf-footer-sn-icon">
        <a href="https://www.linkedin.com/company/perfect-corp" target="_blank" rel="noreferrer noopener nofollow">
          <img src={In}  alt = {'LinkedIn'}/>
        </a>
      </div>
      <div className="pf-footer-sn-icon">
        <a href={webUtils.twitterLink()} target="_blank" rel="noreferrer noopener nofollow">
          <img src={Tt}  alt = {'Twitter'}/>
        </a>
      </div>
    </div>
  );
}
